import React from "react";
import InfoPage from "../components/InfoPage";

function Contact() {
  return (
    <InfoPage
      eyebrow="LET'S CONNECT"
      title="Contact Us"
      subtitle="Have a question about a style or your appointment? Get in touch."
      sections={[
        {
          title: "Appointments",
          content:
            "Placeholder: Explain how clients should request, confirm, or ask about appointments.",
        },
        {
          title: "Email",
          content: "Placeholder: Add your business email address.",
        },
        {
          title: "Phone or Text",
          content: "Placeholder: Add your business phone number, if applicable.",
        },
        {
          title: "Service Location",
          content:
            "Placeholder: Add your service area, salon address, or instructions for receiving the location after booking.",
        },
        {
          title: "Business Hours",
          content: "Placeholder: Add your usual business and response hours.",
        },
      ]}
    />
  );
}

export default Contact;